// Duplicated from ab-common
import { connect } from 'react-redux';
import { branch, compose, renderNothing } from 'recompose';
import { applicationLoadingSelector, notesAlertOnlySelector, notesFilterSelector, notesSetAddingAction, notesSetAddingPrivateAction, notesSetWithAlertOnlyAction } from '@applyboard/ab-common';
import addingNewNote from "./addingNewNote";

// used by the TopBar of the Notes Tab

var noteTabBarSelector = function noteTabBarSelector(state) {
  return {
    filter: notesFilterSelector(state),
    withAlertOnly: notesAlertOnlySelector(state),
    loading: applicationLoadingSelector(state)
  };
};
var noteTabBarDispatch = function noteTabBarDispatch(dispatch) {
  return {
    onAddNote: function onAddNote(visibility) {
      return dispatch(addingNewNote(visibility));
    },
    onCollapseNote: function onCollapseNote() {
      return dispatch(notesSetAddingAction(false, false));
    },
    onCollapsePrivateNote: function onCollapsePrivateNote() {
      return dispatch(notesSetAddingPrivateAction(false, false));
    },
    setNoteWithAlertsOnly: function setNoteWithAlertsOnly(value) {
      return dispatch(notesSetWithAlertOnlyAction(value));
    }
  };
};
var noteTabBarEnhancer = compose(connect(noteTabBarSelector, noteTabBarDispatch), branch(function (props) {
  return props.hideLegacyNoteTabBar;
}, renderNothing));
export default noteTabBarEnhancer;